import activities from './activities';
import activityGroups from './activityGroups';
import articulationGymnasticsCollections from './articulationGymnasticsCollections';
import articulationGymnasticsLevels from './articulationGymnasticsLevels';
import authentication from './authentication';
import climbStepThreeCollections from './climbStepThreeCollections';
import climbStepThreeLevels from './climbStepThreeLevels';
import climbStepThreeExtraCollections from './climbStepThreeExtraCollections';
import climbStepThreeExtraLevels from './climbStepThreeExtraLevels';
import climbStepTwoCollections from './climbStepTwoCollections';
import climbStepTwoLevels from './climbStepTwoLevels';
import climbStepTwoExtraCollections from './climbStepTwoExtraCollections';
import climbStepTwoExtraLevels from './climbStepTwoExtraLevels';
import climbStepOneCollections from './climbStepOneCollections';
import climbStepOneLevels from './climbStepOneLevels';
import climbStepOneExtraCollections from './climbStepOneExtraCollections';
import climbStepOneExtraLevels from './climbStepOneExtraLevels';
import coupons from './coupons';
import dailyMap from './dailyMap';
import discoverStepThreeCollections from './discoverStepThreeCollections';
import discoverStepThreeLevels from './discoverStepThreeLevels';
import discoverStepTwoCollections from './discoverStepTwoCollections';
import discoverStepTwoLevels from './discoverStepTwoLevels';
import discoverStepOneCollections from './discoverStepOneCollections';
import discoverStepOneLevels from './discoverStepOneLevels';
import discoverStepOneExtraCollections from './discoverStepOneExtraCollections';
import discoverStepOneExtraLevels from './discoverStepOneExtraLevels';
import discoverStepTwoExtraCollections from './discoverStepTwoExtraCollections';
import discoverStepTwoExtraLevels from './discoverStepTwoExtraLevels';
import discoverStepThreeExtraCollections from './discoverStepThreeExtraCollections';
import discoverStepThreeExtraLevels from './discoverStepThreeExtraLevels';
import feedback from './feedback';
import findWordsStepThreeCollections from './findWordsStepThreeCollections';
import findWordsStepThreeLevels from './findWordsStepThreeLevels';
import findWordsStepThreeExtraCollections from './findWordsStepThreeExtraCollections';
import findWordsStepThreeExtraLevels from './findWordsStepThreeExtraLevels';
import findWordsStepTwoCollections from './findWordsStepTwoCollections';
import findWordsStepTwoLevels from './findWordsStepTwoLevels';
import findWordsStepTwoExtraCollections from './findWordsStepTwoExtraCollections';
import findWordsStepTwoExtraLevels from './findWordsStepTwoExtraLevels';
import findWordsStepOneCollections from './findWordsStepOneCollections';
import findWordsStepOneLevels from './findWordsStepOneLevels';
import findWordsStepOneExtraCollections from './findWordsStepOneExtraCollections';
import findWordsStepOneExtraLevels from './findWordsStepOneExtraLevels';
import flashCardsStepThreeCollections from './flashCardsStepThreeCollections';
import flashCardsStepThreeLevels from './flashCardsStepThreeLevels';
import flashCardsStepThreeExtraCollections from './flashCardsStepThreeExtraCollections';
import flashCardsStepThreeExtraLevels from './flashCardsStepThreeExtraLevels';
import flashCardsStepTwoCollections from './flashCardsStepTwoCollections';
import flashCardsStepTwoLevels from './flashCardsStepTwoLevels';
import flashCardsStepOneCollections from './flashCardsStepOneCollections';
import flashCardsStepOneLevels from './flashCardsStepOneLevels';
import flashCardsStepOneExtraCollections from './flashCardsStepOneExtraCollections';
import flashCardsStepOneExtraLevels from './flashCardsStepOneExtraLevels';
import flashCardsStepTwoExtraCollections from './flashCardsStepTwoExtraCollections';
import flashCardsStepTwoExtraLevels from './flashCardsStepTwoExtraLevels';
import help from './help';
import licensing from './licensing';
import memoryStepThreeCollections from './memoryStepThreeCollections';
import memoryStepThreeGroups from './memoryStepThreeGroups';
import memoryStepThreeLevels from './memoryStepThreeLevels';
import memoryStepThreeExtraCollections from './memoryStepThreeExtraCollections';
import memoryStepThreeExtraGroups from './memoryStepThreeExtraGroups';
import memoryStepThreeExtraLevels from './memoryStepThreeExtraLevels';
import memoryStepTwoCollections from './memoryStepTwoCollections';
import memoryStepTwoGroups from './memoryStepTwoGroups';
import memoryStepTwoLevels from './memoryStepTwoLevels';
import memoryStepTwoExtraCollections from './memoryStepTwoExtraCollections';
import memoryStepTwoExtraGroups from './memoryStepTwoExtraGroups';
import memoryStepTwoExtraLevels from './memoryStepTwoExtraLevels';
import memoryStepOneCollections from './memoryStepOneCollections';
import memoryStepOneGroups from './memoryStepOneGroups';
import memoryStepOneLevels from './memoryStepOneLevels';
import memoryStepOneExtraCollections from './memoryStepOneExtraCollections';
import memoryStepOneExtraGroups from './memoryStepOneExtraGroups';
import memoryStepOneExtraLevels from './memoryStepOneExtraLevels';
import notes from './notes';
import notifications from './notifications';
import paintingCollections from './paintingCollections';
import paintingGroups from './paintingGroups';
import paintingLevels from './paintingLevels';
import parrot from './parrot';
import payment from './payment';
import readAndThinkBonusLevels from './readAndThinkBonusLevels';
import readAndThinkCollections from './readAndThinkCollections';
import readAndThinkLevels from './readAndThinkLevels';
import readTogetherBonusLevels from './readTogetherBonusLevels';
import readTogetherCollections from './readTogetherCollections';
import readTogetherLevels from './readTogetherLevels';
import replenishmentCollections from './replenishmentCollections';
import replenishmentLevels from './replenishmentLevels';
import routing from './routing';
import speechSounds from './speechSounds';
import student from './student';
import students from './students';
import subactivities from './subactivities';
import subscriptions from './subscriptions';
import subscriptionStatus from './subscriptionStatus';
import tooltips from './tooltips';
import treasureHuntCollections from './treasureHuntCollections';
import treasureHuntGroups from './treasureHuntGroups';
import treasureHuntLevels from './treasureHuntLevels';
import user from './user';
import wallet from './wallet';
import wheelOfFortuneCollections from './wheelOfFortuneCollections';
import wheelOfFortuneLevels from './wheelOfFortuneLevels';

export default {
  activities,
  activityGroups,
  articulationGymnasticsCollections,
  articulationGymnasticsLevels,
  authentication,
  climbStepThreeCollections,
  climbStepThreeLevels,
  climbStepThreeExtraCollections,
  climbStepThreeExtraLevels,
  climbStepTwoCollections,
  climbStepTwoLevels,
  climbStepTwoExtraCollections,
  climbStepTwoExtraLevels,
  climbStepOneCollections,
  climbStepOneLevels,
  climbStepOneExtraCollections,
  climbStepOneExtraLevels,
  coupons,
  dailyMap,
  discoverStepThreeCollections,
  discoverStepThreeLevels,
  discoverStepTwoCollections,
  discoverStepTwoLevels,
  discoverStepOneCollections,
  discoverStepOneLevels,
  discoverStepOneExtraCollections,
  discoverStepOneExtraLevels,
  discoverStepTwoExtraCollections,
  discoverStepTwoExtraLevels,
  discoverStepThreeExtraCollections,
  discoverStepThreeExtraLevels,
  feedback,
  findWordsStepThreeCollections,
  findWordsStepThreeLevels,
  findWordsStepThreeExtraCollections,
  findWordsStepThreeExtraLevels,
  findWordsStepTwoCollections,
  findWordsStepTwoLevels,
  findWordsStepTwoExtraCollections,
  findWordsStepTwoExtraLevels,
  findWordsStepOneCollections,
  findWordsStepOneLevels,
  findWordsStepOneExtraCollections,
  findWordsStepOneExtraLevels,
  flashCardsStepThreeCollections,
  flashCardsStepThreeLevels,
  flashCardsStepThreeExtraCollections,
  flashCardsStepThreeExtraLevels,
  flashCardsStepTwoCollections,
  flashCardsStepTwoLevels,
  flashCardsStepOneCollections,
  flashCardsStepOneLevels,
  flashCardsStepOneExtraCollections,
  flashCardsStepOneExtraLevels,
  flashCardsStepTwoExtraCollections,
  flashCardsStepTwoExtraLevels,
  help,
  licensing,
  memoryStepThreeCollections,
  memoryStepThreeGroups,
  memoryStepThreeLevels,
  memoryStepThreeExtraCollections,
  memoryStepThreeExtraGroups,
  memoryStepThreeExtraLevels,
  memoryStepTwoCollections,
  memoryStepTwoGroups,
  memoryStepTwoLevels,
  memoryStepTwoExtraCollections,
  memoryStepTwoExtraGroups,
  memoryStepTwoExtraLevels,
  memoryStepOneCollections,
  memoryStepOneGroups,
  memoryStepOneLevels,
  memoryStepOneExtraCollections,
  memoryStepOneExtraGroups,
  memoryStepOneExtraLevels,
  notifications,
  notes,
  paintingCollections,
  paintingGroups,
  paintingLevels,
  parrot,
  payment,
  readAndThinkBonusLevels,
  readAndThinkCollections,
  readAndThinkLevels,
  readTogetherBonusLevels,
  readTogetherCollections,
  readTogetherLevels,
  replenishmentCollections,
  replenishmentLevels,
  routing,
  speechSounds,
  student,
  students,
  subactivities,
  subscriptions,
  subscriptionStatus,
  tooltips,
  treasureHuntCollections,
  treasureHuntGroups,
  treasureHuntLevels,
  user,
  wallet,
  wheelOfFortuneCollections,
  wheelOfFortuneLevels,
};
